import { WMICCachedJsonRPCService, WMICJsonRPCService } from 'wmic-pe-portals-transport-js';
import { getProxiedServiceUrl } from 'wmic-portals-url-js';

export default class WMICUserService {
    static getAvailableProducerCodesForCurrentUser(additionalHeaders = {}) {
        return WMICCachedJsonRPCService.send(
            getProxiedServiceUrl('gatewayUser'),
            'getAvailableProducerCodesForCurrentUser',
            [],
            additionalHeaders
        );
    }

    static hasUserSystemPermission(permission, additionalHeaders = {}) {
        return WMICCachedJsonRPCService.send(
            getProxiedServiceUrl('gatewayUser'),
            'hasUserSystemPermission',
            [permission],
            additionalHeaders
        );
    }

    static hasUserPermission(permission, additionalHeaders = {}) {
        return WMICCachedJsonRPCService.send(
            getProxiedServiceUrl('gatewayUser'),
            'hasUserPermission',
            [permission],
            additionalHeaders
        );
    }

    static hasUserAccessToAccountPolicies(accountNumber, additionalHeaders = {}) {
        return WMICCachedJsonRPCService.send(
            getProxiedServiceUrl('gatewayUser'),
            'hasUserAccessToAccountPolicies',
            [accountNumber],
            additionalHeaders
        );
    }

    /**
     * This is the server responsible for dealing with the Gateway Current User Information
     * whic is used in the AuthenticationContext.jsx
     * */

    static getGatewayCurrentUser(additionalHeaders = {}) {
        return WMICCachedJsonRPCService.send(
            getProxiedServiceUrl('gatewayUser'),
            'getCurrentUser',
            [],
            additionalHeaders
        );
    }

    static updateUserPreferredLanguage(localeCode, additionalHeaders = {}) {
        return WMICJsonRPCService.send(
            getProxiedServiceUrl('gatewayUser'),
            'updateUserPreferredLanguage_WMIC',
            [localeCode],
            additionalHeaders
        );
    }
}
